module.exports = __webpack_public_path__ + "static/contact-963d9e4a9a6aa61fe79ea24137dc40e4.jpg";